import { gql } from 'graphql-request';
import {
  LifestyleDetectionCenterX,
  LifestyleDetectionCenterY,
  LifestyleDetectionConfidence,
  LifestyleDetectionHeight,
  LifestyleDetectionID,
  LifestyleDetectionIsLargest,
  LifestyleDetectionX1,
  LifestyleDetectionX2,
  LifestyleDetectionWidth,
  LifestyleDetectionY2,
  LifestyleDetectionY1,
  LifestyleDetectionDetectRequestID
} from '../lifestyleDetectionsTypes';
import { ProductID } from '../../products/productsTypes';

export type FetchLifestyleDetection = {
  id: LifestyleDetectionID;
  category: string;
  centerX: LifestyleDetectionCenterX;
  centerY: LifestyleDetectionCenterY;
  x1: LifestyleDetectionX1;
  x2: LifestyleDetectionX2;
  y1: LifestyleDetectionY1;
  y2: LifestyleDetectionY2;
  width: LifestyleDetectionWidth;
  height: LifestyleDetectionHeight;
  confidence: LifestyleDetectionConfidence;
  isLargest: LifestyleDetectionIsLargest;
  detectRequestId: LifestyleDetectionDetectRequestID;
  largestSearchResult: {
    externalId: ProductID;
  }[];
};

export const LIFESTYLE_DETECTIONS_BY_IMAGE_URL_QUERY = gql`
  query LifestyleDetectionsByImageUrl(
    $imageUrl: String!
    $imageId: ID
    $lifestyleId: ID
  ) {
    lifestyleDetectionsByImageUrl(
      imageUrl: $imageUrl
      imageId: $imageId
      lifestyleId: $lifestyleId
    ) {
      detectRequestId
      sql
      nodes {
        id
        category
        centerX
        centerY
        x1
        x2
        y1
        y2
        width
        height
        confidence
        isLargest
        detectRequestId
        largestSearchResult {
          externalId
        }
      }
      paginationInfo {
        totalCount
      }
    }
  }
`;
